import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-elevenplus-helpclub',
    templateUrl: './elevenplus-helpclub.component.html',
    styleUrls: ['./elevenplus-helpclub.component.css'],
    standalone: false
})
export class ElevenplusHelpclubComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  openForm(): void {
    window.open("https://forms.zohopublic.in/sehyogacademy1/form/OPENDAYREGISTRATIONFORM1/formperma/FtsOX-Wg-1k-MM2OsZ_yPPOBier7whYC4ENY-bwjGS8", "_blank");
  }

}
